import * as React from 'react'
import mapboxgl from 'mapbox-gl'
import { useMap } from './MapContext'

interface Props {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
}

const NavigationControl: React.FC<Props> = ({ position = 'top-left' }) => {
  const map = useMap()

  React.useEffect(() => {
    if (!map) return

    const control = new mapboxgl.NavigationControl({ showCompass: false })
    map.addControl(control, position)

    return () => {
      map.removeControl(control)
    }
  }, [map, position])

  return null
}

export default NavigationControl
